import axios from 'axios';
import { config } from '../apiConfig';

const CreateTicket = async (parameters) => {
    let result = '';
    let response = await axios.post(`${config.url}/api/mvc/Tickets/CreateTicket`, parameters).catch(() => {
        return false;
    });
    if (response.status === 200) {
        result = response.data;
    } else {
        result = 'failed';
    }
    return result;
}

export default CreateTicket;